export function getTechSpecProps(facets: any) {
  const notSpecs = [
    'category',
    'vendor',
    'category_2',
    'active_dascosales_web',
    'discontinued',
    'made_in_usa' // TODO Remove if data is implemented
  ]

  return Object.keys(facets)
    .filter(key => !notSpecs.includes(key))
    .reduce((obj: any, key: string) => {
      obj[key] = facets[key]
      return obj
    }, {})
}
